// extracted by mini-css-extract-plugin
export default {"LeadershipChainList":"_2cXuLDG53yMgd_y_Cn4GDk","Badge":"_2zTlJXU-GKgsujE6xci98z"};